import { ref } from 'vue';
export default {
  __name: 'moduleCard',
  props: {
    title: {
      type: String,
      default: ''
    },
    gradient: {
      type: String,
      default: ''
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const props = __props;
    // 渐变色
    const color = ref(['linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))', 'none']);
    const __returned__ = {
      props,
      color
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};